<template>
  <el-dialog
    v-el-drag-dialog
    no="ReleaseJY"
    :visible.sync="innerVisible"
    :title="$t('SeaExport.ReleaseJY')"
    :close-on-click-modal="false"
    width="500px"
    @close="dialogClose"
  >
    <div style="margin: 10px;fontWeight:bold">
      <span>{{ job.mbl }}</span>
    </div>
    <div style="flex:1;margin: 10px;fontWeight:bold">
      <span>{{ job.vessel }}</span>
      <span style="margin-left: 10px">{{ job.voyageFlight }}</span>
    </div>
    <div style="fontWeight:bold;margin: 10px">
      <span> {{ containerDesc }}</span>
    </div>
    <div style="display:flex;margin-top:20px;">
      <span :style="{ margin: '5px', width: $selectByLang('50px', '50px', '50px', '70px', '70px', '70px')}">{{ $t('SeaExport.ReleaseRemarks') }}</span>
      <div style="width:70%;margin-left:10px">
        <el-input v-model="remark" type="textarea" :rows="5" no="remark" />
      </div>
    </div>
    <div style="display:flex;margin-top:20px;">
      <span :style="{ margin: '5px', width: $selectByLang('50px', '50px', '50px', '70px', '70px', '70px')}">{{ $t('SeaExport.RequireDate') }}</span>
      <div style="width:50%;margin-left:10px">
        <el-date-picker
          v-model="requireDate"
          no="45"
          type="datetime"
          value-format="yyyy-MM-dd HH:mm:ss"
          format="yyyy-MM-dd HH:mm"
          style="width: 100%"
        />
      </div>
    </div>
    <div slot="footer">
      <el-button type="primary" @click="jyRelease()">{{ $t('common.btn.confirm') }}</el-button>
      <el-button @click="dialogClose">{{ $t('common.btn.cancel') }}</el-button>
    </div>
  </el-dialog>
</template>

<script>

import { getLoading4Cxt } from '@/utils/utilBaseElement'
import { postRlsInfo } from '@/api/booking/jyWarehouse'
import { getObjectByCache } from '@/utils/basicDataCache'
import { basicCacheKeys } from '@/utils/cacheConfig'
import $store from '@/store'
import { ContainerUtil } from '@/class/cargo/model/utils/ContainerUtil'

export default {
  name: 'JyReleaseDialog',
  props: {
    visible: { type: Boolean, default: false },
    callback: { type: Function, default: null },
    job: { type: Object, required: true },
    containers: { type: Array, default: () => [] }
  },
  data() {
    return {
      innerVisible: false,
      loading: false,
      remark: '',
      requireDate: '',
      containerDesc: ''
    }
  },
  computed: {

  },
  watch: {
    visible(newVal) {
      this.innerVisible = newVal
      if (this.visible) {
        this.onShow()
      }
    },
    innerVisible(newVal) {
      this.$emit('update:visible', newVal)
    }
  },
  created() {
    if (this.visible) {
      this.onShow()
    }
  },
  methods: {
    dialogClose() {
      this.$emit('update:visible', false)
    },
    onShow() {
      this.remark = ''
      this.requireDate = ''
      this.containerDesc = ContainerUtil.getMasterJobContainerDesc(this.job)
    },
    jyRelease() {
      const consigner = getObjectByCache(basicCacheKeys.basic_data_User, 'userId', $store.getters.userId)
      if (!consigner) {
        this.$message.warning(this.$t('SeaExport.consignerNotNull'))
        return
      }
      const warehouse = getObjectByCache(basicCacheKeys.basic_data_Company, 'cmpIdx', this.job.warehouseCmp)
      if (!warehouse) {
        this.$message.warning(this.$t('SeaExport.warehouseNotNull'))
        return
      }
      const jySeaExpOrderList = []
      // 目前精谕接口只支持单箱模式，一次只能推一个箱子，每个箱子生产一个订单
      for (const item of this.containers) {
        const jySeaExpOrder = {
          custbizNo: this.job.jobNo + '-' + item.containerId,
          custOp: consigner.chineseName ? consigner.chineseName : consigner.englishName,
          vessel: this.job.vessel,
          voyage: this.job.voyageFlight,
          blNo: this.job.mbl,
          etd: this.job.etd,
          portName: this.job.dischargingPort,
          warehouse: warehouse.chineseName,
          jySeaExpCont: {
            contSize: item.eqSize,
            contType: item.eqType,
            custbizNo: this.job.jobNo + '-' + item.containerId
          },
          remark: this.remark,
          requireDate: this.requireDate
        }
        jySeaExpOrderList.push(jySeaExpOrder)
      }
      const data = {
        jobUuid: this.job.uuid,
        warehouse: warehouse.cnShortName,
        branchId: this.$store.getters.currentOfficeId,
        jySeaExpOrderList: jySeaExpOrderList
      }
      this.loading = getLoading4Cxt()
      postRlsInfo(data).then(res => {
        if (res.data) {
          this.$message.warning(res.data)
        } else {
          this.$message.success(this.$t('SeaExport.SentSuccessfully'))
        }
        this.dialogClose()
        if (this.callback) {
          this.callback()
        }
      }).catch(() => {
      }).finally(() => {
        this.loading.close()
      })
    }
  }
}
</script>

<style scoped>

</style>
